import { toggle } from "./toggle";

export default toggle("rulers");
